import { useState } from 'react'
import { translate, languageName, isSameLanguage, t } from '../services/translate.js'

// Text mit "See translation"-Link wie bei Facebook/Instagram: Ausgangssprache
// wird automatisch erkannt und in die Gerätesprache übersetzt.
export default function TranslatableText({ text, as: Tag = 'p', className }) {
  const [translation, setTranslation] = useState(null) // { text, sourceLang }
  const [showTranslation, setShowTranslation] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function handleToggle() {
    if (translation) {
      setShowTranslation(s => !s)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const result = await translate(text)
      setTranslation(result)
      setShowTranslation(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const sameLanguage = translation && isSameLanguage(translation.sourceLang)
  const shown = showTranslation && !sameLanguage ? translation.text : text

  let label
  if (loading) label = t('translating')
  else if (sameLanguage) label = null
  else if (showTranslation) label = t('original')
  else label = t('see')

  return (
    <Tag className={className}>
      {shown}
      <span className="translate-row">
        {label && (
          <button
            type="button"
            className="translate-btn"
            onClick={handleToggle}
            disabled={loading}
          >
            {label}
          </button>
        )}
        {showTranslation && !sameLanguage && (
          <span className="translate-note">
            {t('from', { lang: languageName(translation.sourceLang) })}
          </span>
        )}
        {sameLanguage && (
          <span className="translate-note">{t('same')}</span>
        )}
        {error && <span className="translate-note translate-error">{error}</span>}
      </span>
    </Tag>
  )
}
